import styled from "styled-components";

import { COLOR } from "config/color";

export const HeaderWrapper = styled.div`
  img {
    width: 100vw;
    height: auto;
  }

  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  .banner_content {
    position: absolute;
    top: 3rem;
    color: ${COLOR.fontColorSecondary};
    white-space: pre;
    width: 100%;
    text-align: center;
    text-align: -webkit-center;
    .title {
      font-size: 1.6rem;
      margin-bottom: 0.6rem;
      line-height: 130%;
    }
    .logo {
      width: 10rem;
      margin-bottom: 2rem;
    }
    .subtitle {
      font-size: 1.4rem;
      letter-spacing: 4px;
      margin-bottom: 2rem;
    }
    .more {
      font-size: 1.2rem;
      margin-bottom: 9px;
      padding-bottom: 4px;
      border-bottom: 1px solid ${COLOR.fontColorSecondary};
      width: fit-content;
    }
    svg {
      color: white;
      font-size: 1.6rem;
    }
  }
`;

export const GetGiftFormWrapper = styled.div`
  background: ${COLOR.fontColorSecondary};
  padding: 40px 0 40px 0;
  #la-prairie-form {
    padding-top: 35px;
  }
  img {
    width: 100vw;
    height: auto;
  }
  .title {
    white-space: pre-line;
    font-size: 1.4rem;
    line-height: 2.2rem;
  }
  .line {
    width: 45px;
    height: 1px;
    background: ${COLOR.fontColorPrimary};
    margin: 8px auto 10px auto;
  }
  .subtitle {
    font-size: 1.4rem;
    line-height: 2rem;
    white-space: pre-line;
    margin-bottom: 5px;
    margin-bottom: 2.5rem;
    font-weight: 300;
  }
  .note {
    color: ${COLOR.fontColorGray};
    font-size: 1rem;
    letter-spacing: 1.2px;
    line-height: 137%;
    margin-bottom: 30px;
  }
  .content {
    padding: 30px 8vw 0 8vw;
    .introduce {
      font-size: 1.25rem;
      line-height: 160%;
      text-align: left;
      white-space: pre-line;
      color: ${COLOR.fontColorPrimary};
    }
  }
  .row {
    display: flex;
    flex-wrap: wrap;
    .col {
      width: 100%;
      > p.MuiTypography-root {
        display: none;
      }
    }
    .col.gender {
      display: flex;
      > p.MuiTypography-root {
        display: block;
        color: initial;
        margin-top: 4px;
        margin-right: 10px;
      }
    }
    .col + .col {
      margin-left: 10px;
    }
    .introduce {
      margin-bottom: 0px;
    }
  }

  .row:nth-child(1) .col {
    text-align: start;
    .MuiFormGroup-root {
      display: block;
      .MuiFormControlLabel-root {
        margin: 0px 10px 0 0;
      }
    }
  }
  .row:nth-child(2) {
    > .col:nth-child(1) {
      flex: 2;
    }
    > .col:nth-child(2) {
      flex: 3;
    }
  }
  .row:nth-child(3) {
    > .col:nth-child(1) {
      flex: 4;
    }
    > .col:nth-child(2),
    > .col:nth-child(3) {
      flex: 2;
    }
  }
  .row:nth-child(4) {
    input + button {
      margin-left: 10px;
    }
    input {
      flex: 3;
    }
    button {
      height: 100%;
      font-size: 1.2rem;
      flex: 2;
      min-width: initial;
    }
  }
  /* .row:nth-child(8) {
    font-size: 1.2rem;
    margin: 15px 0 35px 0;
  } */
  .row:nth-child(8) {
    margin-top: 20px;
    flex-direction: row-reverse;
    > p:nth-child(1) {
      flex: 11;
      color: ${COLOR.fontColorPrimary};
      text-align: start;
      font-size: 1.25rem;
      line-height: 160%;
    }
    > div:nth-child(2) {
      flex: 1;
      .MuiFormControlLabel-root {
        margin: 0px;
      }
      .MuiCheckbox-root {
        padding: 0px;
      }
      svg {
        font-size: 2rem;
      }
    }
    .Mui-error {
      margin: 0px;
    }
    .note {
      text-decoration: underline;
    }
  }

  .note.small {
    font-size: 1rem;
    line-height: 160%;
    .col:nth-child(1) {
      flex: 1;
    }
    .col:nth-child(2) {
      flex: 30;
    }
  }
  .justify {
    text-align: justify !important;
  }
  .note.small.justify {
    margin-bottom: 0px;
  }
  .submit_btn {
    margin-top: 30px;
    width: 100%;
    font-weight: normal;
    margin-bottom: 20px;
    padding: 0.8rem 2.2rem;
    font-size: 1.2rem;
  }
`;
export const ProductSectionWrapper = styled.div`
  background-color: ${COLOR.backgroundPrimary};
  padding-top: 30px;
  color: ${COLOR.fontColorPrimary};
  .title {
    white-space: pre-line;
    font-size: 1.4rem;
    line-height: 1.8rem;
  }
  .line {
    width: 45px;
    height: 1px;
    background: ${COLOR.fontColorPrimary};
    margin: 8px auto 10px auto;
  }
  .subtitle {
    font-size: 1.4rem;
    white-space: pre-line;
    letter-spacing: 3px;
  }
  .product {
    margin: 2rem 0;
    .banner {
      width: 100%;
      margin-bottom: 3rem;
    }
    .product_group {
      padding: 2rem;
    }
    .product_content {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: -1rem;
      margin-bottom: 3rem;
      width: 100%;
      img {
        width: 50%;
      }
      .wrapper {
        width: 50%;
      }
      .title {
        font-size: 1.2rem;
      }
      .line {
        margin: 10px auto 25px auto;
        width: 50px;
      }
      .price {
        font-size: 1.2rem;
        margin: 10px 0;
      }
      .button {
        font-size: 1rems;
      }
    }
  }
`;
export const ProductCarouselWrapper = styled.div`
  background-color: ${COLOR.backgroundPrimary};
  padding-top: 30px;
  color: ${COLOR.fontColorPrimary};
  .label {
    background-color: #000b73;
    color: white;
    padding: 2px 1.5rem;
    width: 5rem;
    font-size: 1.2rem;
    margin: 0 auto;
    border-radius: 100px;
    margin-bottom: 5px;
    font-weight: bold;
    margin-top: 1rem;
  }
  .title {
    white-space: pre-line;
    font-size: 1.4rem;
    line-height: 1.8rem;
  }
  .line {
    width: 45px;
    height: 1px;
    background: ${COLOR.fontColorPrimary};
    margin: 8px auto 10px auto;
  }
  .subtitle {
    font-size: 1.4rem;
    white-space: pre-line;
    letter-spacing: 3px;
  }
  .price {
    font-size: 1.4rem;
    line-height: 3rem;
    font-weight: 300;
    color: ${COLOR.fontColorGray};
  }
  .btn {
    background: ${COLOR.fontColorGray};
    width: 160px;
    height: 40px;
    color: white;
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 137%;
    border-radius: 0px;
  }
  .btn:hover {
    opacity: 0.8;
    background: ${COLOR.fontColorGray};
  }
  .product_content {
    .title {
      margin-bottom: 3rem;
      font-weight: bold;
    }
    .line {
      margin: 10px auto 5px auto;
      width: 50px;
    }
    .price {
      margin: 10px 0;
    }
  }
  .carousel {
    position: relative;
    margin-bottom: 25px;
    > .MuiBox-root {
      > .MuiBox-root {
        width: calc(60vw - 22px);
        margin: auto;
      }
      .MuiPaper-root .MuiButton-root {
        position: absolute;
        top: calc(48vw - 100px);
        svg {
          font-size: 10vw;
        }
      }
      & .MuiButton-root:nth-child(1) {
        left: -12px;
      }
      & .MuiButton-root:nth-child(3) {
        right: -12px;
      }
      .MuiMobileStepper-dots {
        display: none;
      }
    }
  }
  .note {
    padding: 20px 10px;
    background: ${COLOR.fontColorGray};

    .title {
      color: white;
      font-size: 1.7rem;
      line-height: 3rem;
      letter-spacing: 3px;
    }

    .content {
      color: white;
      white-space: pre-line;
      font-size: 1.2rem;
      line-height: 160%;
      letter-spacing: 2px;
    }

    .line {
      margin: 0px auto 8px auto;
      background: white;
    }
  }
`;

export const ProductInfoCarouselWrapper = styled.div`
  background-color: white;
  padding: 4rem 0;
  color: ${COLOR.fontColorPrimary};
  .title {
    white-space: pre-line;
    font-size: 1.6rem;
    line-height: 130%;
  }
  .line {
    width: 45px;
    height: 1px;
    background: ${COLOR.fontColorPrimary};
    margin: 10px auto 5px auto;
  }
  .subtitle {
    font-size: 1.5rem;
    white-space: pre-wrap;
    margin-bottom: 4rem;
    margin-top: 1rem;
    letter-spacing: 2px;
    font-weight: 300;
  }
  .content {
    font-size: 1.2rem;
    line-height: 160%;
  }
  .product_content {
    text-align: justify;
    padding: 0 8vw;
    .title {
      margin-top: 30px;
      font-size: 1.4rem;
    }
    .content {
      white-space: pre-line;
      margin-top: 25px;
      margin-bottom: 20px;
    }
    .line {
      margin: 10px 0px;
      width: 50px;
    }
  }
  .carousel {
    position: relative;
    > .MuiBox-root {
      > .MuiBox-root {
        width: calc(88vw - 22px);
        margin: auto;
      }
      .MuiButton-root {
        position: absolute;
        top: calc(48vw - 60px);
        svg {
          font-size: 10vw;
        }
      }
      & .MuiButton-root:nth-child(1) {
        left: -12px;
      }
      & .MuiButton-root:nth-child(3) {
        right: -12px;
      }
      .MuiMobileStepper-dots {
        display: none;
      }
    }
  }
`;

export const ContentInfoWrapper = styled.div`
  width: 100%;
  color: ${COLOR.fontColorPrimary};
  .contentInfo-wrapper {
    background: ${COLOR.backgroundPrimary};
    position: relative;
  }
  img {
    width: 100%;
  }
  .contentInfo_content {
    padding: 40px 30px 30px 30px;
    .title {
      white-space: pre-line;
      font-size: 1.6rem;
      line-height: 130%;
    }
    .line {
      width: 45px;
      height: 1px;
      background: ${COLOR.fontColorPrimary};
      margin: 10px auto;
    }
    .subtitle {
      white-space: pre-line;
      font-size: 1.4rem;
      letter-spacing: 2px;
      line-height: 137%;
      margin-bottom: 30px;
      margin-top: 10px;
    }
    .more {
      white-space: pre-line;
      text-align: justify;
      font-size: 1.12rem;
      line-height: 160%;
    }
  }
`;
export const VideoWrapper = styled.div`
  width: 100%;
  color: ${COLOR.fontColorPrimary};

  .video-wrapper {
    position: relative;
    video {
      width: 100%;
    }
    .title {
      margin-bottom: 1.5rem;
      white-space: pre-line;
    }
    svg {
      background: transparent;
    }
    .icon-wrapper {
      position: absolute;
      bottom: 5px;
      right: 5px;
      z-index: 5;
    }

    video[poster] {
      width: 100vw;
      height: auto;
    }
  }

  .show-control {
    .video-react-button.video-react-big-play-button.video-react-big-play-button-left {
      display: none;
    }
  }

  .hide-control {
    .video-react-control-bar,
    .video-react-button {
      display: none;
    }
  }
`;

export const ErrorModalWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${COLOR.fontColorSecondary};
  width: 65%;
  padding: 20px 40px 40px 40px;
  &:focus {
    outline: none;
  }
  .header {
    display: flex;
    position: relative;
    top: -5px;
    right: -25px;
    svg {
      color: ${COLOR.fontColorPrimary};
      margin-left: auto;
      font-size: 1.5rem;
    }
  }

  .content {
    display: grid;
    height: 100%;
    .content_item {
      margin: 5px 0;
      line-height: 2;
      font-size: 1rem;
      text-align: start;
      font-weight: 300;
      span {
        font-size: 0.93rem;
        color: gray;
      }
    }

    .close_btn {
      width: 80%;
      margin: 20px auto;
      padding: 0.8rem 2.2rem;
      font-size: 1.2rem;
    }
  }
`;
